module.exports = __webpack_public_path__ + "static/contact-1-1-79be4ba27d663be1e2a59319e326c977.jpg";